import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

export function usePartnerMyTeam() {
  return useQuery({
    queryKey: dashboardQueryKeys.partnerMyTeam(),
    queryFn: () => dashboardApi.getPartnerMyTeam({ limit: 20, offset: 0 }),
  });
}
